<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{title}}<button type="button" class="close"
                           @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="errorMessage">
            <div>{{ errorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group id="amountFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('amount')"
                          :invalid-feedback="errorForField('amount')"
                          label="Amount"
                          label-for="amountField"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input id="amountField" v-model="fee.amount"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group id="descriptionFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('description')"
                          :invalid-feedback="errorForField('description')"
                          label="Description"
                          label-for="descriptionField"
                          label-class="text-right">
              <b-form-input id="descriptionField" v-model="fee.description"></b-form-input>
              <div class="pt-1">
                <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/> <span class="text-muted align-bottom">This will be visible to the patient.</span>
              </div>
            </b-form-group>

            <b-form-group id="npiFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('npi')"
                          :invalid-feedback="errorForField('npi')"
                          label="NPI"
                          label-for="npiField"
                          label-class="text-right">
              <b-form-input id="npiField" v-model="fee.coProvider.npi"></b-form-input>
            </b-form-group>
            <b-form-group id="tinFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('tin')"
                          :invalid-feedback="errorForField('tin')"
                          label="TIN"
                          label-for="tinField"
                          label-class="text-right">
              <b-form-input id="tinField" v-model="fee.coProvider.tin"></b-form-input>
            </b-form-group>
            <b-form-group id="facilityNameFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('facilityName')"
                          :invalid-feedback="errorForField('facilityName')"
                          label="Facility Name"
                          label-for="facilityNameField"
                          label-class="text-right">
              <b-form-input id="facilityNameField" v-model="fee.coProvider.facilityName"></b-form-input>
            </b-form-group>
            <b-form-group id="firstNameFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('firstName')"
                          :invalid-feedback="errorForField('firstName')"
                          label="First Name"
                          label-for="firstNameField"
                          label-class="text-right">
              <b-form-input id="firstNameField" v-model="fee.coProvider.firstName"></b-form-input>
            </b-form-group>
            <b-form-group id="lastNameFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('lastName')"
                          :invalid-feedback="errorForField('lastName')"
                          label="Last Name"
                          label-for="lastNameField"
                          label-class="text-right">
              <b-form-input id="lastNameField" v-model="fee.coProvider.lastName"></b-form-input>
            </b-form-group>
            <b-form-group id="suffixFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('suffix')"
                          :invalid-feedback="errorForField('suffix')"
                          label="Suffix"
                          label-for="suffixField"
                          label-class="text-right">
              <b-form-input id="suffixField" v-model="fee.coProvider.suffix"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Add Fee</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'EstimateCopFeeModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      title: {
        type: String,
        default: 'Add Estimate CoProvider Fee'
      }
    },

    data () {
      return {
        fee: {
          coProvider: {
            npi: '',
            tin: '',
            firstName: '',
            lastName: '',
            middleName: '',
            suffix: '',
            facilityName: '',
            amount: 0,
            description: '',
            organizationId: this.$store.organization.organizationId
          },
          description: '',
          amount: 0
        },
        isSaving: false,
        errorMessage: ''
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.fee = {
          coProvider: {
            npi: '',
            tin: '',
            firstName: '',
            lastName: '',
            middleName: '',
            suffix: '',
            facilityName: '',
            description: '',
            organizationId: this.$store.organization.organizationId
          },
          description: '',
          amount: 0
        }
      },

      validate () {
        this.clearAllErrors()
        const amountValue = parseFloat(this.fee.amount)
        if (!amountValue) {
          this.addErrorForField('amount', 'An amount is required.')
        }

        if (amountValue < 0) {
          this.addErrorForField('amount', 'Amount must be greater then zero.')
        }

        if (!this.fee.description) {
          this.addErrorForField('description', 'A description is required.')
        }

        if (this.fee.description.length > 255) {
          this.addErrorForField('description', 'The description must be less then 255 characters')
        }

        if (!this.fee.coProvider.npi) {
          this.addErrorForField('npi', 'A NPI is required.')
        }

        if (!this.fee.coProvider.tin) {
          this.addErrorForField('tin', 'A TIN is required.')
        }

        return !this.hasErrors()
      },

      save () {

        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.fee.amount = parseFloat(this.fee.amount)
        this.fee.coProvider.description = this.fee.description

        this.$emit('addNewCopFee', this.fee)
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
